import { useContext } from 'react';
import { AuthContext } from './AuthProvider';

// Re-export AuthProvider for backward compatibility
export { AuthProvider } from './AuthProvider';

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
